'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosLoopStrong = function IoIosLoopStrong(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 3.8c9 0 16.3 7.2 16.3 16.2 0 1.1-0.1 2.2-0.4 3.3l0 0.3-1.9-0.4 0.1-0.3c0.1-0.9 0.3-1.9 0.3-2.9 0-7.9-6.5-14.4-14.4-14.4-5.2 0-9.9 2.8-12.5 7.4l-0.2 0.2-1.6-0.9 0.2-0.3c2.9-5 8.2-8.2 14.1-8.2z m12.5 23.2l0.2-0.2 1.6 0.9-0.2 0.3c-2.8 5-8.2 8.2-14.1 8.2-9 0-16.2-7.2-16.2-16.2 0-1.1 0-2.2 0.3-3.3l0-0.3 1.9 0.4-0.1 0.3c-0.1 0.9-0.3 1.9-0.3 2.9 0 7.9 6.5 14.4 14.4 14.4 5.2 0 9.9-2.8 12.5-7.4z m-2.5-7h10l-5 5z m-30 0l5-5 5 5h-10z' })
        )
    );
};

exports.default = IoIosLoopStrong;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-loop-strong.js
// module id = 2436
// module chunks = 0